import type { DataTableColumn } from '@/components/custom/erp';

interface ImportTaxRateRow {
  taxCode: string;
  taxName: string;
  nameAlias?: string;
  taxRate: number;
  outputTaxAccount: string;
  status?: string;
}

export const taxRateColumns: DataTableColumn<ImportTaxRateRow>[] = [
  { field: 'taxCode', headerName: 'Mã thuế', width: 100 },
  { field: 'taxName', headerName: 'Tên thuế', width: 200 },
  { field: 'taxRate', headerName: 'Thuế suất', width: 100 },
  { field: 'outputTaxAccount', headerName: 'TK thuế', width: 150 }
];

export const taxRateDetailColumns: DataTableColumn<ImportTaxRateRow>[] = [
  { field: 'taxCode', headerName: 'Mã thuế', width: 100 },
  { field: 'taxName', headerName: 'Tên thuế', width: 200 },
  { field: 'nameAlias', headerName: 'Tên khác', width: 200 },
  { field: 'taxRate', headerName: 'Thuế suất (%)', width: 100 },
  { field: 'outputTaxAccount', headerName: 'TK thuế', width: 150 },
  { field: 'status', headerName: 'Trạng thái', width: 150 }
];
